export default __webpack_public_path__ + "static/media/Kayak_Rentals_Top.e556bae7.png";